import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { AoiComponent } from './components/aoi/aoi.component';

import { HeaderComponent } from './components/header/header.component';
import { ToolsComponent } from './components/tools/tools.component';

import { Basemaps } from './services/basemaps';
import { Http2Service } from './services/http2.service';
import { LoadingService } from './services/loading.service';
import { LegendOptionsService } from './services/legend-options.service';
import { UtilsService } from './services/utils.service';

@NgModule({
    declarations: [
        AppComponent,
        AoiComponent,
        HeaderComponent,      
        ToolsComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule
    ],
    providers: [Basemaps, Http2Service, HttpClient, LegendOptionsService, LoadingService, UtilsService],
    bootstrap: [AppComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ]
})
export class AppModule { }
